// Global
import React, { useState } from 'react';

// Lib
import { BoK } from 'lib/templates/Feature.BOKF.model';

// Local
import RichTextA11yWrapper from 'helpers/RichTextA11yWrapper/RichTextA11yWrapper';
import SVG from 'helpers/SVG/SVG';

export type AlertNoticeProps = BoK.Content.AlertNotice & AlertNoticeParams;

export type AlertNoticeParams = {
  params: {
    Icon?: {
      Value?: {
        value: string;
      };
    };
    BgColor?: {
      Value?: {
        value: string;
      };
    };
  };
};

export const AlertNotice = (props: AlertNoticeProps): JSX.Element => {
  const { Icon, BgColor } = props?.params || {};
  const { CopyText } = props?.fields || {};
  const [closeAlert, setCloseAlert] = useState<boolean>(false);

  const closeAlertNotice = () => {
    setCloseAlert(true);
    // After state update, recalculate total height
    setTimeout(() => {
      updateAlertBannerHeight();
    }, 0);
  };

  const updateAlertBannerHeight = () => {
    // Get all alert containers that aren't hidden
    const alertContainers = document.querySelectorAll('.alert-container:not(.hidden)');

    if (alertContainers.length === 0) {
      document.documentElement.style.removeProperty('--alert-notice-height');
    } else {
      const headerElement = document.querySelector('header');
      let totalHeight = 0;
      // Only process alerts that are above the header
      alertContainers.forEach((container) => {
        if (headerElement) {
          const alertRect = container.getBoundingClientRect();
          const headerRect = headerElement.getBoundingClientRect();

          // Check if alert is above header
          if (alertRect.top < headerRect.top) {
            totalHeight += container.clientHeight;
          }
        }
      });
      // Update the CSS variable with total height
      document.documentElement.style.setProperty('--alert-notice-height', `${totalHeight}px`);
    }

    // Dispatch custom event to notify other components that alerts have changed
    const alertChangedEvent = new CustomEvent('alertheightchanged', {
      detail: {
        alertHeight:
          parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue('--alert-notice-height')
          ) || 0,
      },
    });
    document.dispatchEvent(alertChangedEvent);
  };

  if (!props?.fields) {
    return <></>;
  }

  return (
    <section
      className={`component alert-container flex flex-row items-center justify-between w-full px-8 md:px-10 py-2 md:py-3 ${
        BgColor?.Value?.value || 'bg-light-background-feedback'
      } ${closeAlert ? 'hidden' : ''}`}
    >
      <div className="flex items-center gap-x-2 md:gap-x-4">
        <SVG
          className=" block [&_svg]:w-6 [&_svg]:h-6 [&_path]:fill-light-fill-inverse"
          svg={Icon?.Value?.value || 'icon-filled-info'}
          hidden={false}
        ></SVG>

        <RichTextA11yWrapper
          field={CopyText}
          className="p3-medium text-light-fill-inverse rtaw alert-notice"
        />
      </div>
      <button className="" onClick={closeAlertNotice} type="button">
        <span className="sr-only">Close Alert Notice</span>
        <SVG
          className="block [&_svg]:w-6 [&_svg]:h-6 [&_path]:fill-light-fill-inverse "
          svg="icon-close"
          hidden={false}
        ></SVG>
      </button>
    </section>
  );
};

export default AlertNotice;
